import React from "react";
import { ExternalLink, Home } from "lucide-react";
import { AvailableOwnerListing } from "../types/ownerDashboard.types";
import { getPublicPropertyPath } from "../utils/selectAvailableOwnerListings";

interface AvailablePropertyCardProps {
  listing: AvailableOwnerListing;
}

export default function AvailablePropertyCard({ listing }: AvailablePropertyCardProps) {
  return (
    <a
      href={getPublicPropertyPath(listing.id)}
      target="_blank"
      rel="noopener noreferrer"
      className="flex w-full flex-col gap-3 rounded-2xl border border-white/[0.08] bg-[#1c2128] p-4 transition-colors hover:border-[#6ea8ff]/40 sm:flex-row sm:items-start sm:justify-between"
      data-testid={`available-property-card-${listing.id}`}
    >
      <div className="flex min-w-0 flex-1 items-start gap-2">
        <Home className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#6ea8ff]" aria-hidden />
        <div className="min-w-0 space-y-1">
          <h3 className="truncate text-sm font-semibold text-[#f0f6fc]">{listing.title}</h3>
          <p className="line-clamp-2 text-xs text-[#8b949e]">{listing.address}</p>
        </div>
      </div>

      <span className="inline-flex shrink-0 items-center gap-1 self-start text-xs font-semibold text-[#6ea8ff]">
        Ver anúncio
        <ExternalLink className="h-3.5 w-3.5" aria-hidden />
      </span>
    </a>
  );
}
